export default [
  {
    path: '/bidPage',
    name: 'bidPage',
    component: () => import('@views/getJob/bidPage.vue'),
    meta: {
      title: '投标页面'
    }
  },
  {
    path: '/getJob',
    name: 'getJob',
    component: () => import('@views/getJob/index.vue'),
    meta: {
      title: '找活干'
    }
  },
  {
    path: '/getJobJianYiDetail',
    name: 'getJobSimpleDetail',
    component: () => import('@views/getJob/getJobSimpleDetail.vue'),
    meta: {
      title: '找活干_简易详情'
    }
  },
  {
    path: '/getJobBiaoZhunDetail',
    name: 'getJobStandardDetail',
    component: () => import('@views/getJob/getJobStandardDetail.vue'),
    meta: {
      title: '找活干_标准详情'
    }
  },
  {
    path: '/bidResult',
    name: 'bidResult',
    component: () => import('@views/getJob/bidResult.vue'),
    meta: {
      title: '已接活'
    }
  },
  {
    path: '/publicity',
    name: 'publicity',
    component: () => import('@views/getJob/publicity.vue'),
    meta: {
      title: '评标结果公示页面'
    }
  },
  {
    path: '/getWorkAdvertising',
    name: 'getWorkAdvertising',
    component: () => import('@views/getJob/getWorkAdvertising.vue'),
    meta: {
      title: '发布找活广告'
    }
  },
  {
    path: '/hirePartyDetail',
    name: 'hirePartyDetail',
    component: () => import('@views/getJob/hirePartyDetail.vue'),
    meta: {
      title: '招工方详情'
    }
  },
  {
    path: '/getJobPublishSuccess',
    name: 'getJobPublishSuccess',
    component: () => import('@views/getJob/getJobPublishSuccess.vue'),
    meta: {
      title: '找活信息发布成功页面'
    }
  }
]
